import { Component, Inject, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataSourceOptions } from 'devextreme/data/data_source';
import { ABaseComponent } from 'src/app/shared/modules/ui/components/abstract/a-base.component';
import { DataSourceService } from '../../../../shared/modules/my-common/services/datasource.service';
import { UiService } from '../../../../shared/modules/ui/services/ui.service';
import { LoggerService, LoopBackAuth, VehicleService, VehicleServiceApi } from '../../../../shared/sdk';
import notify from 'devextreme/ui/notify';
import { HelperService } from '../../services/helper.service';
import { ExtLoopBackAuth } from 'src/app/shared/modules/ext-sdk/services/ext-sdk-auth.service';

@Component({
  selector: 'app-vehicle-service-details-tab-schedules',
  templateUrl: './vehicle-service-details-tab-schedules.component.html',
  styleUrls: ['./vehicle-service-details-tab-schedules.component.scss'],
  providers: [],
})
export class VehicleDetailsTabSchedulesComponent extends ABaseComponent {
  _vehicleService: VehicleService;

  @Input()
  set vehicleService(v: VehicleService) {
    this._vehicleService = v;
    this.changeHandle();
  }
  get vehicleService() {
    return this._vehicleService;
  }

  dso: DataSourceOptions;

  constructor(
    protected logger: LoggerService,
    protected ui: UiService,
    protected dss: DataSourceService,
    protected dialog: MatDialog,
    public helperService: HelperService,
    @Inject(LoopBackAuth) private auth: ExtLoopBackAuth,
  ) {
    super(logger);
  }

  changeHandle() {}

  async onScheduleInserting(event: any): Promise<void> {
    try {
      event.data.id = event.data.__KEY__;
      event.data.createdAt = new Date();
      const { id, username } = this.auth.getCurrentUserData();
      event.data.createdBy = { id, username };

      let { schedules } = this.vehicleService;
      schedules = [{ ...event.data, __KEY__: undefined }, ...this.vehicleService.schedules];
      this.vehicleService.schedules = schedules; // Update the local state with predicted data

      // Call the API to add the new schedule
      const updatedVehicleService = await this.dss
        .getApi<VehicleServiceApi>(VehicleService)
        .mySaveWithRelated(this.vehicleService.id, { schedules })
        .toPromise();

      // Update the local state with the response
      this.vehicleService.schedules = updatedVehicleService.schedules;
    } catch (error) {
      notify('Error inserting schedule', 'error', 3000);
      console.error('Error inserting schedule:', error);
      event.cancel = true;
    }
  }

  async onScheduleUpdating(event: any): Promise<void> {
    try {
      const { schedules } = this.vehicleService;
      const index = schedules.findIndex((schedule: any) => schedule.id === event.key.id);
      if (index !== -1) {
        schedules[index] = { ...schedules[index], ...event.newData, updatedAt: new Date() };
        const { schedules: updatedSchedules } = await this.dss
          .getApi<VehicleServiceApi>(VehicleService)
          .mySaveWithRelated(this.vehicleService.id, { schedules })
          .toPromise();
        this.vehicleService.schedules = updatedSchedules;
      }
    } catch (error) {
      notify('Error updating schedule', 'error', 3000);
      console.error('Error updating schedule:', error);
      event.cancel = true;
    }
  }

  async onScheduleRemoving(event: any): Promise<void> {
    const { schedules } = this.vehicleService;
    const index = schedules.findIndex((schedule: any) => schedule.id === event.key.id);
    if (index !== -1) {
      schedules.splice(index, 1);
      const { schedules: updatedSchedules } = await this.dss
        .getApi<VehicleServiceApi>(VehicleService)
        .mySaveWithRelated(this.vehicleService.id, { schedules })
        .toPromise();
      this.vehicleService.schedules = updatedSchedules;
    }
  }
}
